<div style="display: flex; align-items: center; justify-content: center; flex-direction: row; height: 100%">
	<mat-card appearance="outlined" class="signin-card">
		@if (show) {
			<button mat-icon-button class="signin-return-button" (click)="onReturn()">
				<mat-icon svgIcon="acies_undo" class="return-icon"></mat-icon>
				{{ 'login.backbtn' | translate }}
			</button>
		}

		<span class="cloud-svg"></span>

		<mat-card-title>{{ 'login.headerWelcome.label' | translate }}</mat-card-title>
		@if (show) {
			<mat-card-subtitle>{{ email_address }}</mat-card-subtitle>
		}
		@if (hasInvite) {
			<mat-card-subtitle>
				<span [innerHTML]="'login.inviteSubheader' | translate"></span>
			</mat-card-subtitle>
		}
		<mat-card-content class="signin-card-content">
			<form>
				@if (!show) {
					<!-- Errors sit in the line each field reserves below itself, so they never move the field; the email error shows once the field is left or the form submitted. -->
					<mat-form-field appearance="outline">
						<input type="email" id="emailInput" matInput autofocus placeholder="{{ 'login.inputEmail.placeholder' | translate }}" [formControl]="emailFormControl" />
						@if (emailFormControl.hasError('email')) {
							<mat-error>{{ 'login.inputEmail.error' | translate }}</mat-error>
						}
					</mat-form-field>
				}
				@if (show) {
					<mat-form-field appearance="outline">
						<input id="passwordInput" [type]="hidePass ? 'password' : 'text'" matInput placeholder="Password" [formControl]="passwordFormControl" [errorStateMatcher]="passwordErrorMatcher" />
						<button mat-icon-button matSuffix (click)="onKeyDown($event)" (keydown)="onKeyDown($event)">
							<mat-icon svgIcon="{{ hidePass ? 'acies_viewoff' : 'acies_view' }}"></mat-icon>
						</button>
						<mat-error>{{ 'login.inputPassword.error' | translate }}</mat-error>
					</mat-form-field>
				}

				@if (error) {
					<p class="error">{{ error }}</p>
				}

				<div>
					<div class="button" class="signin-button">
						<!-- The spinner replaces the label inside the button, so loading never moves anything. -->
						<button mat-raised-button class="hover-class" color="primary" [disabled]="isLoading" (click)="onSignIn()">
							@if (isLoading) {
								<img class="signin-button-spinner" src="./assets/spinner2.gif" />
							}
							<span [class.signin-button-label-hidden]="isLoading">{{ buttonTranslateString | translate }}</span>
						</button>
					</div>
					@if (!show) {
						<mat-checkbox [disableRipple]="true" class="signin-checkbox" [(ngModel)]="rememberMe" (change)="onChangeRemember($event)" [ngModelOptions]="{ standalone: true }">
							{{ 'login.chkRemember.label' | translate }}
						</mat-checkbox>
					}
					@if (show) {
						<a href="javascript:void(0);" class="signin-forgot-password" (click)="handleForgotPassword()">
							{{ 'login.inputPassword.forgotten' | translate }}
						</a>
					}
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</div>
